import React, { useEffect, useState } from "react";
import moment from "moment";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "reactstrap";

import { Heading } from "components/Heading";
import { PageHeadings, PageTitles } from "../../constants";
import StatBoxes from "./StatBoxes";
import RetentionGraph from "./RetentionGraph";
import EngagementStatBoxes from "./EngagementStatBoxes";
import Header from "./Header";
import { userMetricsApi } from "../../api/api.service";
import { getApiFetch } from "../../utils/commonUtils";
import { dateTimeFormat } from "../../utils/dateFormatUtils";
import { findPlanFromNumericVal, findStatusFromNumericVal } from "./utils";

const initialRangeValue = [
  { startDate: undefined, endDate: undefined, key: "selection" },
];

const UserAnalytics = () => {
  const [filters, setFilters] = useState({ status: 1, plan: 1 });
  const [range, setRange] = useState(initialRangeValue);
  const [hasUserSelectedDate, setHasUserSelectedDate] = useState(false);
  const [metricsData, setMetricsData] = useState({});
  const [loading, setLoading] = useState(false);

  const getDateRangeParams = (dateRange) => {
    if (!hasUserSelectedDate) return {};

    const params = {};
    if (dateRange?.startDate) {
      params.startDate = moment(dateRange.startDate)
        .startOf("day")
        .format(dateTimeFormat.apiDateTimeFormat);
    }
    if (dateRange?.endDate) {
      params.endDate = moment(dateRange.endDate)
        .endOf("day")
        .format(dateTimeFormat.apiDateTimeFormat);
    }

    return params;
  };

  const params = {
    ...(filters.status !== 1 && {
      status: findStatusFromNumericVal(filters.status),
    }),
    ...(filters.plan !== 1 && {
      plan: findPlanFromNumericVal(filters.plan),
    }),
    ...getDateRangeParams(range[0]),
  };

  useEffect(() => {
    getApiFetch(setLoading, setMetricsData, userMetricsApi, undefined, params);
  }, [filters.status, filters.plan, range, hasUserSelectedDate]);

  const handleFilterChange = (value, type) => {
    setFilters((prev) => ({ ...prev, [type]: value }));
  };

  const handleRangeChange = ({ selection }) => {
    const { startDate, endDate } = selection;
    const safeEndDate =
      endDate instanceof Date && !isNaN(endDate) ? endDate : startDate;
    setRange([{ ...selection, endDate: safeEndDate }]);
    setHasUserSelectedDate(true);
  };

  const handleRangeClear = (setIsOpen) => {
    if (setIsOpen) setIsOpen(false);
    setHasUserSelectedDate(false);
    setRange(initialRangeValue);
  };

  return (
    <>
      <div className="page-content">
        <Helmet>
          <title>{PageTitles.USER_ANALYTICS}</title>
        </Helmet>
        <Container fluid className="user-analytics">
          <Heading heading={PageHeadings.USER_ANALYTICS} />
          <Row>
            <Col xl="8" lg="8" md="12" xs="12">
              <RetentionGraph data={metricsData} loading={loading} />
            </Col>
            <Col xl="4" lg="4" md="12" xs="12">
              <Row>
                <StatBoxes data={metricsData} isVertical loading={loading} />
              </Row>
            </Col>
          </Row>
          <Header
            statusFilterVal={filters.status}
            planFilterVal={filters.plan}
            filterUpdateHandler={handleFilterChange}
            range={range}
            onRangeChange={handleRangeChange}
            onRangeClear={handleRangeClear}
            hasUserSelectedDate={hasUserSelectedDate}
          />
          <Row>
            <EngagementStatBoxes data={metricsData} loading={loading} />
          </Row>
        </Container>
      </div>
    </>
  );
};

export default UserAnalytics;
